import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import CheckBox from '../../form/CheckBox';
import TypeTextEditor from '../../form/TypeTextEditor';

class OptInForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                            disabled={true}
                        />
                    </div>
                    <div className="col-sm-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="name"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Megnevezés"
                        />
                    </div>
                    <div className="col-sm-4">
                        <label className="control-label">&nbsp;</label>
                        <CheckBox
                            name="public"
                            value={this.props.values.public}
                            label="Publikus"
                            saveChanges={ this.props.setFieldValue }
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <TypeTextEditor
                            name="description"
                            label="Leírás"
                            data={this.props.values}
                            componentConfig={this.props.componentConfig}
                            getFieldProps={this.props.getFieldProps}
                            setFieldValue={this.props.setFieldValue}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(OptInForm);
